<template>
    <div>
        <Item
            v-if="
                ['item', 'inventory_dashboard', 'item_new'].includes(
                    $route.name
                )
            "
        />
        <PurchaseOrder v-if="$route.name === 'purchase_order'" />
        <Receipt v-else-if="$route.name === 'receipt'" />
    </div>
</template>

<script>
import Item from "./item/index";
import PurchaseOrder from "./purchase-order/index";
import Receipt from "./receipt/index";
export default {
    components: {
        Item,
        PurchaseOrder,
        Receipt
    }
};
</script>
